import {useCallback, useState} from 'react';

export function useToggleState(initialValue: boolean) {
	const [value, setValue] = useState(initialValue);

	const handleSwitch = useCallback(() => setValue(oldValue => !oldValue), []);

	return [value, handleSwitch, setValue] as const;
}

useToggleState.displayName = 'useToggleState';
